<template>
    <div>
        <template v-if="parcels">
            <template v-if="this.balane ? true : false">
                <template v-for="(parcel, index) in parcels">
                    <parcel-item
                        @count="countPrice"
                        :key="index"
                        :parcel="parcel"
                        :checkbox="true"
                        :markets="marketsRef"
                        :parcelTypes="parcelTypesRef"
                        :country="parcel.flight.country_id"
                    />
                </template>
            </template>
            <template v-else>
                <template v-for="(parcel, index) in parcels">
                    <parcel-item
                        @count="countPrice"
                        :key="index"
                        :parcel="parcel"
                        :checkbox="false"
                        :markets="marketsRef"
                        :parcelTypes="parcelTypesRef"
                        :country="parcel.flight.country_id"
                        :currency="parcel.flight.country.currency"
                    />
                </template>
            </template>
        </template>

        <div class="w-100 d-flex justify-content-center" v-else>
            <div
                class="spinner-grow text-primary"
                role="status"
                style="width: 3rem; height: 3rem"
            >
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <!-- <div class="modals" v-if="deliverySuccsess">
            <div class="modals-inner">
                <h2 class="modals-inner-title">გაფრთხილება</h2>
                <button
                    class="modals-inner-closer"
                    @click="deliverySuccsess = false"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12.121"
                        height="12.121"
                        viewBox="0 0 12.121 12.121"
                    >
                        <g
                            id="close-circle"
                            transform="translate(-244.109 -260.109)"
                        >
                            <path
                                id="Vector"
                                d="M0,10,10,0"
                                transform="translate(245.17 261.17)"
                                fill="none"
                                stroke="#12202b"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                            />
                            <path
                                id="Vector-2"
                                data-name="Vector"
                                d="M10,10,0,0"
                                transform="translate(245.17 261.17)"
                                fill="none"
                                stroke="#12202b"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                            />
                        </g>
                    </svg>
                </button>

                <p class="mt-3 alert">
                    თქვენს მისამართზე მიტანის სერვირი გააქტიურდა.
                </p>

                <div class="alert alert-warning mt-3" role="alert">
                    გაითვალისწინეთ ამანათი რომელიც ექვემდებარება განბაჟებას
                    მიტანის სერვისი არ აქტიურდება უნდა ეწვიოთ ფილიალს ამანთის
                    გასატანად.
                </div>
            </div>
        </div> -->

        <!-- <div class="modals" v-if="deliveryError">
            <div class="modals-inner">
                <h2 class="modals-inner-title">გაფრთხილება</h2>
                <button
                    class="modals-inner-closer"
                    @click="deliveryError = false"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12.121"
                        height="12.121"
                        viewBox="0 0 12.121 12.121"
                    >
                        <g
                            id="close-circle"
                            transform="translate(-244.109 -260.109)"
                        >
                            <path
                                id="Vector"
                                d="M0,10,10,0"
                                transform="translate(245.17 261.17)"
                                fill="none"
                                stroke="#12202b"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                            />
                            <path
                                id="Vector-2"
                                data-name="Vector"
                                d="M10,10,0,0"
                                transform="translate(245.17 261.17)"
                                fill="none"
                                stroke="#12202b"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                            />
                        </g>
                    </svg>
                </button>

                <p class="mt-3 alert">
                    მიტანის სერვისი არ გააქტიურდა. მიტანის სერვისის
                    გასააქტიურებლად საჭიროა ყველა ამანათზე თანხა იყოს გადახდილი
                    და ამანათი არ ექვემდებარებოდეს განბაჟებას.
                </p>
            </div>
        </div> -->
    </div>
</template>

<script>
import { defineComponent, onBeforeMount, ref } from "@vue/composition-api";
import { useParcels } from "../../hooks/parcels";
import parcelItem from "./parcelItem";
import { Notyf } from "notyf";
import Swal from "sweetalert2";

export default defineComponent({
    components: {
        "parcel-item": parcelItem,
    },
    props: {
        id: {
            type: String,
            default: null,
        },
        balane: {
            type: Number,
            default: 0,
        },
    },
    setup(props) {
        const debet = ref(false);

        const marketsRef = ref(null);
        const parcelTypesRef = ref(null);
        const fullPrice = ref(0.0);
        const ids = ref([]);

        const { getParcels, parcels } = useParcels();

        const countPrice = (e) => {
            if (e.type) {
                fullPrice.value += Number(e.item.price);
                ids.value.push(e.item.id);
            } else {
                fullPrice.value -= Number(e.item.price);
                let index = ids.value.indexOf(e.item.id);
                ids.value.splice(index, 1);
            }
        };

        const onPay = () => {
            if (fullPrice.value > props.balane) {
                Swal.fire({
                    icon: "error",
                    title: "ბალანსზე არ არის საკმარისი თანხა",
                    confirmButtonText: "დახურვა",
                });
                return;
            }
            axios({
                url: "api/pay",
                method: "POST",
                data: {},
            }).then((e) => {
                if (e.data.status) {
                    window.location.reload();
                } else {
                    Swal.fire({
                        icon: "error",
                        title: e.data.mass,
                        confirmButtonText: "დახურვა",
                    });
                }
            });
        };

        const onMarkets = async () => {
            // let res = null;
            // try {
            //     res = await axios({
            //         method: "get",
            //         url: "/api/markets",
            //     });
            //     marketsRef.value = res.data;
            // } catch (error) {
            //     console.log(error.response);
            // }
        };
        const onParcelType = async () => {
            let res = null;
            try {
                res = await axios({
                    method: "get",
                    url: "/api/parcel_type",
                });
                parcelTypesRef.value = res.data;
            } catch (error) {
                console.log(error.response);
            }
        };

        const onCheckDebet = async () => {
            let res = null;
            try {
                res = await axios({
                    method: "get",
                    url: "/api/checkDebt",
                });

                if (res.data.status) {
                    // Swal.fire({
                    //     icon: "error",
                    //     title: "თქვენს ანგარიშზე ფიქსირდება დავალიანება გთხოვთ შეავსეთ ბალანსი და დააჭირეთ გადახდის ღილაკს.",
                    //     confirmButtonText: "დახურვა",
                    // });
                    debet.value = true;
                }
            } catch (error) {
                console.log(error.response);
            }
        };

        onBeforeMount(async () => {
            await onParcelType();
            await onMarkets();
            await getParcels(props.id);
        });

        return {
            parcels,
            countPrice,
            fullPrice,
            onPay,
            marketsRef,
            parcelTypesRef,
            debet,
        };
    },
});
</script>
